import Layout from './components/Layout';


export default {
	Layout
}